var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63577 1.384L3.39062 5.15349L13.187 6.01433L11.3149 1.90379C11.0232 1.26328 10.2383 1.02031 9.63577 1.384Z",
    fill: "#84C70D",
    fillOpacity: 0.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87872 13.2607C2.07586 14.3802 2.97118 15.2798 4.09506 15.4503C5.21101 15.6196 6.21871 15.7859 7.7664 15.7859C9.31409 15.7859 10.3218 15.6196 11.4377 15.4503C12.5616 15.2798 13.4569 14.3802 13.6541 13.2607C13.8062 12.3969 13.9449 11.6468 13.9449 10.1958C13.9449 8.74475 13.8062 7.99466 13.6541 7.1309C13.4569 6.01138 12.5616 5.11178 11.4377 4.94127C10.3218 4.77196 9.31409 4.60571 7.7664 4.60571C6.21871 4.60571 5.21101 4.77196 4.09506 4.94127C2.97118 5.11178 2.07586 6.01138 1.87872 7.1309C1.72662 7.99466 1.58789 8.74475 1.58789 10.1958C1.58789 11.6468 1.72662 12.3969 1.87872 13.2607Z",
    fill: "#84C70D",
    fillOpacity: 0.19,
    stroke: "#84C70D",
    strokeWidth: 1.82143
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1998 11.9022H10.7067C9.73175 11.9022 8.94141 11.1118 8.94141 10.1369C8.94141 9.16193 9.73175 8.37158 10.7067 8.37158H14.1998C14.8705 8.37158 15.4141 8.91524 15.4141 9.58587V10.6879C15.4141 11.3585 14.8705 11.9022 14.1998 11.9022Z",
    fill: "#84C70D",
    fillOpacity: 0.19,
    stroke: "#84C70D",
    strokeWidth: 1.82143,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39062 5.15349L9.63577 1.384C10.2383 1.02031 11.0232 1.26328 11.3149 1.90379L13.187 6.01433",
    stroke: "#84C70D",
    strokeWidth: 1.82143,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewWallet);
export default __webpack_public_path__ + "static/media/overview-wallet.cf9664db5746c96e77c9e8c505f47049.svg";
export { ForwardRef as ReactComponent };